import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { Skill } from "@app/models/rest/skill";
import { SkillRestService } from "@app/services/hal/skill-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class SkillStore extends RealTimeDataStore<Skill> {
  constructor() {
    const skillRestService = inject(SkillRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(skillRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Skill");
  }
}
